import 'css-chunksrc/client/scenes/taskStatuses/statuses/statusCreationForm/styles.scss';export default {
  "form": "_form_8veyl_1",
  "iconBox": "_iconBox_8veyl_32",
  "icon": "_icon_8veyl_32",
  "input": "_input_8veyl_48",
  "completion": "_completion_8veyl_65",
  "button": "_button_8veyl_84"
};